import * as React from "react";

function CtiPaperUsaIcon(props) {
  const { className, height, width } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 149 22"
    >
      <defs>
        <clipPath>
          <rect width="149" height="22" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-cti-paper-usa)">
        <path
          data-name="Path 7126"
          d="M-63.43-3.62a3.328,3.328,0,0,1-3.08,1.74c-2.44,0-3.76-1.98-3.76-5.12s1.32-5.12,3.76-5.12a3.031,3.031,0,0,1,2.9,1.68l1.86-1.16a5.019,5.019,0,0,0-4.76-2.62c-3.62,0-5.92,2.98-5.92,7.22S-70.13.22-66.51.22a5.334,5.334,0,0,0,4.82-2.68ZM-49.57-14H-59.83v2.06h4.08V0h2.1V-11.94h4.08Zm4.96,0h-2.1V0h2.1Zm15,0h-5.86V0h2.06V-5.22h3.66c2.72,0,4.64-1.52,4.64-4.4C-25.11-12.52-27.03-14-29.61-14Zm-.04,6.8h-3.76v-4.82h3.76a2.208,2.208,0,0,1,2.4,2.4A2.177,2.177,0,0,1-29.65-7.2Zm8.94,2,1.12-3.2c.36-1.04.86-2.64,1.02-3.24.16.6.72,2.22,1.06,3.22l1.12,3.22Zm3.28-8.8h-2.22L-24.69,0h2.18l1.16-3.32h5.6L-14.57,0h2.24Zm13.72,0H-9.57V0h2.06V-5.22h3.66c2.72,0,4.64-1.52,4.64-4.4C.79-12.52-1.13-14-3.71-14Zm-.04,6.8H-7.51v-4.82h3.76a2.208,2.208,0,0,1,2.4,2.4A2.177,2.177,0,0,1-3.75-7.2ZM12.81-2.04H5.59V-6.46H9.61V-8.5H5.59v-3.46h6.92V-14H3.49V0h9.32Zm9.12-5.48H17.85v-4.5h4.08a2.145,2.145,0,0,1,2.38,2.26A2.111,2.111,0,0,1,21.93-7.52Zm0-6.48H15.79V0h2.06V-5.54h3.16L23.79,0h2.42L23.35-5.72a3.882,3.882,0,0,0,3.08-4.1C26.43-12.7,24.37-14,21.93-14Zm23.68,0h-2.1v8.2c0,2.56-1.04,3.92-3.24,3.92-2.1,0-3.2-1.42-3.2-4.06V-14h-2.1v8.12c0,3.86,1.8,6.1,5.26,6.1,3.48,0,5.38-2.14,5.38-6.06Zm8.44,5.76c-2.42-.72-3.06-1.2-3.06-2.18,0-.94.7-1.74,2.34-1.74a4.239,4.239,0,0,1,3.26,1.34l1.48-1.5a6.273,6.273,0,0,0-4.58-1.9c-2.58,0-4.62,1.48-4.62,3.9,0,2.5,1.42,3.24,4.38,4.12,2.34.7,3.16,1.24,3.16,2.32,0,1.36-.94,2.04-2.9,2.04A5.116,5.116,0,0,1,49.87-3.5l-1.5,1.46A6.482,6.482,0,0,0,53.35.22c3.58,0,5.18-1.72,5.18-4.24C58.53-6.52,56.81-7.4,54.05-8.24ZM64.27-5.2l1.12-3.2c.36-1.04.86-2.64,1.02-3.24.16.6.72,2.22,1.06,3.22L68.59-5.2ZM67.55-14H65.33L60.29,0h2.18l1.16-3.32h5.6L70.41,0h2.24Z"
          transform="translate(74 18)"
        />
      </g>
    </svg>
  );
}

export default CtiPaperUsaIcon;
